import { Layout } from "antd";
import styled from "styled-components";

export const StyledLayout = styled(Layout)`
  background-color: ${(props) => props.theme.colors.tertiary};
  height: 100vh;
  overflow-x: hidden;
`;
